<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Edit Paket Pengadaan" back_url="paket_pengadaan"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="nama_paket_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Nama Paket Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="nama_paket_pengadaan" type="text" :class="{'p-invalid' : errors.nama_paket_pengadaan}" v-model="form.nama_paket_pengadaan" />
                            <small v-if="errors.nama_paket_pengadaan" id="name-help" class="p-error">Nama Paket Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pagu_anggaran" class="col-12 mb-2 md:col-2 md:mb-0">Pagu Anggaran</label>
                        <div class="col-12 md:col-10">
                            <InputText id="pagu_anggaran" type="text" :class="{'p-invalid' : errors.pagu_anggaran}" v-model="form.pagu_anggaran" />
                            <small v-if="errors.pagu_anggaran" id="name-help" class="p-error">Pagu Anggaran Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="kategori_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Kategori Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="kategori_pengadaan" type="text" :class="{'p-invalid' : errors.kategori_pengadaan}" v-model="form.kategori_pengadaan" />
                            <small v-if="errors.kategori_pengadaan" id="name-help" class="p-error">Kategori Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jenis_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Jenis Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="jenis_pengadaan" type="text" :class="{'p-invalid' : errors.jenis_pengadaan}" v-model="form.jenis_pengadaan" />
                            <small v-if="errors.jenis_pengadaan" id="name-help" class="p-error">Jenis Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ruang_lingkup_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Ruang Lingkup Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ruang_lingkup_pengadaan" type="text" :class="{'p-invalid' : errors.ruang_lingkup_pengadaan}" v-model="form.ruang_lingkup_pengadaan" />
                            <small v-if="errors.ruang_lingkup_pengadaan" id="name-help" class="p-error">Ruang Lingkup Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="spesifikasi_pekerjaan" class="col-12 mb-2 md:col-2 md:mb-0">Spesifikasi Pekerjaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="spesifikasi_pekerjaan" type="text" :class="{'p-invalid' : errors.spesifikasi_pekerjaan}" v-model="form.spesifikasi_pekerjaan" />
                            <small v-if="errors.spesifikasi_pekerjaan" id="name-help" class="p-error">Spesifikasi Pekerjaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="mak" class="col-12 mb-2 md:col-2 md:mb-0">Mata Akun Kegiatan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="mak" type="text" :class="{'p-invalid' : errors.mak}" v-model="form.mak" />
                            <small v-if="errors.mak" id="name-help" class="p-error">Mata Akun Kegiatan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="metode_pemilihan" class="col-12 mb-2 md:col-2 md:mb-0">Metode Pemilihan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="metode_pemilihan" type="text" :class="{'p-invalid' : errors.metode_pemilihan}" v-model="form.metode_pemilihan" />
                            <small v-if="errors.metode_pemilihan" id="name-help" class="p-error">Metode Pemilihan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_mulai_pemilihan_penyedia" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Mulai Pemilihan Penyedia</label>
                        <div class="col-12 md:col-10">
                            <InputText id="jadwal_mulai_pemilihan_penyedia" type="text" :class="{'p-invalid' : errors.jadwal_mulai_pemilihan_penyedia}" v-model="form.jadwal_mulai_pemilihan_penyedia" />
                            <small v-if="errors.jadwal_mulai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Mulai Pemilihan Penyedia Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_selesai_pemilihan_penyedia" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Selesai Pemilihan Penyedia</label>
                        <div class="col-12 md:col-10">
                            <InputText id="jadwal_selesai_pemilihan_penyedia" type="text" :class="{'p-invalid' : errors.jadwal_selesai_pemilihan_penyedia}" v-model="form.jadwal_selesai_pemilihan_penyedia" />
                            <small v-if="errors.jadwal_selesai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Selesai Pemilihan Penyedia Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_mulai_pelaksanaan_kontrak" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Mulai Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <InputText id="jadwal_mulai_pelaksanaan_kontrak" type="text" :class="{'p-invalid' : errors.jadwal_mulai_pelaksanaan_kontrak}" v-model="form.jadwal_mulai_pelaksanaan_kontrak" />
                            <small v-if="errors.jadwal_mulai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Mulai Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_selesai_pelaksanaan_kontrak" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Selesai Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <InputText id="jadwal_selesai_pelaksanaan_kontrak" type="text" :class="{'p-invalid' : errors.jadwal_selesai_pelaksanaan_kontrak}" v-model="form.jadwal_selesai_pelaksanaan_kontrak" />
                            <small v-if="errors.jadwal_selesai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Selesai Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ppk_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Pembuat Komitmen</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ppk_id" type="text" :class="{'p-invalid' : errors.ppk_id}" v-model="form.ppk_id" />
                            <small v-if="errors.ppk_id" id="name-help" class="p-error">Pejabat Pembuat Komitmen Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="draft_kak" class="col-12 mb-2 md:col-2 md:mb-0">Draft KAK</label>
                        <div class="col-12 md:col-10">
                            <InputText id="draft_kak" type="text" :class="{'p-invalid' : errors.draft_kak}" v-model="form.draft_kak" />
                            <small v-if="errors.draft_kak" id="name-help" class="p-error">Draft KAK Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="draft_hps_spesifikasi" class="col-12 mb-2 md:col-2 md:mb-0">Draft HPS Spesifikasi</label>
                        <div class="col-12 md:col-10">
                            <InputText id="draft_hps_spesifikasi" type="text" :class="{'p-invalid' : errors.draft_hps_spesifikasi}" v-model="form.draft_hps_spesifikasi" />
                            <small v-if="errors.draft_hps_spesifikasi" id="name-help" class="p-error">Draft HPS Spesifikasi Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="scan_rkat" class="col-12 mb-2 md:col-2 md:mb-0">Scan RKAT</label>
                        <div class="col-12 md:col-10">
                            <InputText id="scan_rkat" type="text" :class="{'p-invalid' : errors.scan_rkat}" v-model="form.scan_rkat" />
                            <small v-if="errors.scan_rkat" id="name-help" class="p-error">Scan RKAT Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="dokumen_lain" class="col-12 mb-2 md:col-2 md:mb-0">Dokumen Lain</label>
                        <div class="col-12 md:col-10">
                            <InputText id="dokumen_lain" type="text" :class="{'p-invalid' : errors.dokumen_lain}" v-model="form.dokumen_lain" />
                            <small v-if="errors.dokumen_lain" id="name-help" class="p-error">Dokumen Lain Wajib Diisi</small>
                        </div>
                    </div>
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import TreeTable from 'primevue/treetable';
import PermissionService from '../../Services/PermissionService';
import Checkbox from 'primevue/checkbox';
import PermissionTreeTable from '../../Components/PermissionTreeTable';
import MenuTreeTable from '../../Components/MenuTreeTable';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column, 
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        TreeTable,
        Checkbox,
        PermissionTreeTable,
        MenuTreeTable,
    },
    data() {
        return { 
            nodes : null, 
            // selected_permission : [],
            expandedKeys : {}
        }
    },
    permissionService : null,
    props : {
        errors : Array,
        form : Array,
    },
    methods : {
        submitForm(){
            // alert(this.form)
            // this.form.permissions = this.selected_permission;
            Inertia.put(`/paket_pengadaan/${this.form.id}`, this.form);
        },
        console_log(param){
            console.log(param);
        },
    }
}
</script>
